__turbopack_context__.v({
  "checkbox": "ImageUpload-module__RqnweW__checkbox",
  "disabled": "ImageUpload-module__RqnweW__disabled",
  "draggableIcon": "ImageUpload-module__RqnweW__draggableIcon",
  "fullWidth": "ImageUpload-module__RqnweW__fullWidth",
  "meta": "ImageUpload-module__RqnweW__meta",
  "overlayGroup": "ImageUpload-module__RqnweW__overlayGroup",
  "sortItem": "ImageUpload-module__RqnweW__sortItem",
});
